import { findElementById, toggleVisibility } from '../Utils';

export function registerLanguagePicker(): void {
    const LANGUAGE_PICKER = 'languagePicker';
    const LANGUAGE_PICKER_TOGGLE = 'languagePickerToggle';

    const $languagePicker = findElementById<HTMLDivElement>(LANGUAGE_PICKER);
    const $languagePickerToggle = findElementById<HTMLButtonElement>(LANGUAGE_PICKER_TOGGLE);

    if ($languagePicker == null || $languagePickerToggle == null) {
        console.error('LanguagePicker not found, not binding events');
        return;
    }

    const toggleButton = (force?: boolean) => {
        const state = force ?? $languagePickerToggle.getAttribute('aria-expanded') != 'true';

        $languagePickerToggle.setAttribute('aria-expanded', String(state));
        toggleVisibility($languagePicker, state);
    };

    document.addEventListener('click', (e) => {
        const target = e.target as HTMLElement | null;

        if ($languagePickerToggle.contains(target)) {
            toggleButton();
        } else if (!$languagePicker.contains(target)) {
            toggleButton(false);
        }
    }, false);
}
